import React from "react";
import PropTypes from "prop-types";
import { CAlert } from "@coreui/react";

const ErrorMessageAlerts = ({ errorMessages, colorType = "danger" }) => {
  return errorMessages.map((errorMessage, idx) => {
    return (
      <CAlert key={idx} color={colorType}>
        {errorMessage}
      </CAlert>
    );
  });
};

ErrorMessageAlerts.propTypes = {
  errorMessages: PropTypes.array.isRequired,
  colorType: PropTypes.string,
};
export default ErrorMessageAlerts;
